import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import { reduxForm } from 'redux-form'
import Field from '@ynap/field'
import { PasswordInput } from '@ynap/password-input'
import { SimpleAsyncButton } from '@ynap/button'
import Notification from '@ynap/notification'
import { submitAndCollateErrorsPromise, onSubmitFail } from '@ynap/form-utils'
import track from 'react-tracking'
import { trackEditEmailAddress } from '../analytics'
import validate from './validate'
import collateErrors from './collateErrors'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('ChangeEmailForm')

const propTypes = {
    className: PropTypes.string,
    form: PropTypes.string,
    email: PropTypes.string,
    isImpersonatedBy: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    messages: PropTypes.shape({
        changeEmailForm: PropTypes.shape({
            currentEmail: PropTypes.func.isRequired,
            newEmail: PropTypes.func.isRequired,
            password: PropTypes.func.isRequired,
            update: PropTypes.func.isRequired
        }).isRequired,
        errors: PropTypes.shape({
            required: PropTypes.func.isRequired,
            invalid: PropTypes.func.isRequired,
            userExists: PropTypes.func.isRequired,
            authenticationError: PropTypes.func.isRequired,
            generic: PropTypes.func.isRequired,
            global: PropTypes.func.isRequired
        }).isRequired
    }).isRequired
}

@track()
export class ChangeEmailForm extends PureComponent {
    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this)
    }

    @track(trackEditEmailAddress())
    onSubmit(values) {
        const { form, onSubmit } = this.props
        return submitAndCollateErrorsPromise(onSubmit(values, form), values, this.props)
    }

    render() {
        const { className, form, email, handleSubmit, submitting, error, children, messages, isImpersonatedBy } = this.props

        return (
            <form id={form} className={bem(null, { submitting }, className)} onSubmit={handleSubmit(this.onSubmit)}>
                <label className={bem('currentEmailTitle')}>{messages.changeEmailForm.currentEmail()}</label>
                <div className={bem('currentEmail')}>
                    {email ? email : <Skeleton className={bem('emailSkeleton')} />}
                </div>

                <div className={bem('fieldsWrapper')}>
                    <Field type="email" name="logonId" label={messages.changeEmailForm.newEmail()} />
                    {!isImpersonatedBy && (
                        <Field
                            component={PasswordInput}
                            name="x_logonPasswordCurrent"
                            label={messages.changeEmailForm.password()}
                        />
                    )}
                </div>

                <div className={bem('buttonWrapper')}>
                    <SimpleAsyncButton
                        type="submit"
                        loading={submitting}
                        className={bem('submit')}
                        copy={messages.changeEmailForm.update()}
                    />
                </div>

                {error ? <Notification type="error" message={error} className={bem('error')} /> : null}

                {children}
            </form>
        )
    }
}

ChangeEmailForm.propTypes = propTypes

export default reduxForm({ form: 'changeEmail', validate, collateErrors, onSubmitFail })(ChangeEmailForm)
